import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import api from '../../pages/api';

// Custom base query using axios instead of fetch
const axiosBaseQuery = ({ baseUrl } = { baseUrl: '' }) =>
  async ({ url, method, data, params }) => {
    try {
      console.log(`Making API call to: ${baseUrl + url} with method: ${method}`);
      const result = await api({
        url: baseUrl + url,
        method,
        data,
        params,
      });
      console.log('API response:', result.data);
      return { data: result.data };
    } catch (axiosError) {
      console.error('API Error:', axiosError);
      let err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const apiSlice = createApi({
  reducerPath: 'apiSlice',
  baseQuery: axiosBaseQuery({
    baseUrl: '',
  }),
  tagTypes: ['Stats'],
  endpoints: (builder) => ({
    getStats: builder.query({
      query: () => ({
        url: '/stats',
        method: 'GET',
      }),
      providesTags: ['Stats'],
      transformResponse: (response) => {
        console.log('API transformResponse - raw response:', response);
        // Transform the response to match your API format
        if (response.status && response.status.statusCode === 'code-200' && response.data) {
          const transformedData = {
            cityCount: response.data.cityCount || 0,
            storeCount: response.data.storeCount || 0,
            customerCount: response.data.customerCount || 0,
          };
          console.log('API transformResponse - transformed data:', transformedData);
          return transformedData;
        }
        // Fallback values if API response is not in expected format
        const fallbackData = {
          cityCount: 0,
          storeCount: 0,
          customerCount: 0,
        };
        console.log('API transformResponse - using fallback data:', fallbackData);
        return fallbackData;
      },
    }),
  }),
});

export const {
  useGetStatsQuery,
} = apiSlice;